export const otp = {
    title:"Xác minh bảo mật",
    label:"Mã xác minh Email",
    content:"Nhập mã gồm 6 chữ số được gửi đến",
    button:"Xác nhận",
    backToLogin: "Quay lại đăng nhập",
    receivedCode: "Bạn chưa nhận được mã? Yêu cầu mã mới sau ",
    seconds: "{seconds} giây",
    receivedCodeYet:"Bạn chưa nhận được mã?",
    resendCode: "Gửi lại mã"
};
